import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import { longFormatDate } from '@liveauctioneers/caterwaul-components/lib/utils/dates';
import * as React from 'react';
import styled from 'styled-components';

import RegistrationStatusLabel from '@/components/RegisterAuctionBanner/RegistrationStatusLabel';
import { useAppSelector } from '@/redux/hooks';
import {
    getItemSummaryCatalogId,
    getItemSummaryCatalogTitle,
    getItemSummaryStartTime,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { getCatalogUrl } from '@/utils/urls';

type Props = {
    itemId: number;
    openOnBlank?: boolean;
};

const AuctionInfo = ({ itemId, openOnBlank = false }: Props) => {
    const catalogId = useAppSelector((state) => getItemSummaryCatalogId(state, itemId));
    const catalogTitle = useAppSelector((state) => getItemSummaryCatalogTitle(state, itemId));
    const saleStartTs = useAppSelector((state) => getItemSummaryStartTime(state, itemId));

    return (
        <>
            <StyledLink
                route={!openOnBlank}
                target={openOnBlank ? '_blank' : '_self'}
                to={getCatalogUrl(catalogId, catalogTitle)}
            >
                {catalogTitle}
            </StyledLink>
            <div>
                <StyledText
                    colorPrimaryWeak
                    secondary
                >
                    {longFormatDate(saleStartTs)}
                </StyledText>
            </div>
            <div>
                <RegistrationStatusLabel
                    catalogId={catalogId}
                    itemId={itemId}
                    justify
                    showRegister={false}
                />
            </div>
        </>
    );
};

export default React.memo<Props>(AuctionInfo);

const StyledLink = styled(Link)`
    color: ${({ theme }) => theme.colors.black};
    text-decoration: none;
    line-height: 24px;
    font-family: ${({ theme }) => theme.typography.fontSecondary};
`;

const StyledText = styled(Text)`
    line-height: 24px;
`;
